<!-- ======= Hero Section ======= -->
<section class="login-page-section-top ">
    <div class="container">
        <div class="row">
            <div class="col-md-12 size-img back-img">
                <div class="effect-cover">
                    <h3 class="txt-advert animated fadeInUp">Tennis Premier League </h3>
                    <p class="txt-advert-sub animated">Your all-access pass to experience the action on tour</p>
                </div>
            </div>
        </div>
    </div>
    <div *ngFor="let banner of bannerImageList " class="swiper-slide zoom-effect-container banner-image-div">
        <div class="image-card-div" fxLayout="column" fxLayoutAlign="center center" fxFlexFill>
            <div class="headings image-card">
                <img [src]="banner.banner_image_src" class="product-image" alt="banner" />
                <div class="slider-inner-div">
                    <div class="container">
                        <div class="main-heading-banner">
                            <!-- <div class="headings-section-banner">
      <h4 class="tracking-in-contract">CREATIVE</h4>
      <div class="main-heading tracking-in-contract new">
        WEB DESIGN.
      </div>
    </div> -->
                            <div class="sldier-bottom-section"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
<p-toast key="toastmsg" position="top-right"></p-toast>
<section *ngIf="!showForgotPasswordForm" class="login-page-section sign-in-section-main-page">
    <div class="section-title text-center">
        <p> LOGIN NOW !
        </p>
    </div>
    <div class="col-md-12 to-button-toogle">
        <ul class="top-navigation-button">
            <li [routerLinkActive]="'active'">
                <a routerLink="/sign-in">
                    <button>
                        LOGIN
                    </button>
                </a>
            </li>
            <li>
                <a routerLink="/sign-up">
                    <button>
                        REGISTER
                    </button>
                </a>
            </li>
            <!-- <li class="disabled-list">
                <a routerLink="/sign-up">
                    <button>
                        REGISTER
                    </button>
                </a>
            </li> -->
        </ul>
        <p-tabView [(activeIndex)]="activeIndex">
            <p-tabPanel header="LOGIN" class="login-page-ui login">
                <p-tabView class="login-Otp-tabs">
                    <p-tabPanel header="Login With Password">
                        <div class="container">
                            <div class="row">
                                <div class="col-md-12 ">
                                    <div class="col-md-12 login-page">
                                        <form class="login-form" [formGroup]="loginForm" *ngIf="this.loginForm"
                                            (ngSubmit)="onSubmit()">
                                            <div class="name form-lable">
                                                <label for="name_login">Email:<span
                                                        class="mandatory-fields">*</span></label>
                                                <div class="clear"></div>
                                                <input type="email" id="name_login" formControlName="email"
                                                    placeholder="Email Address"
                                                    [ngClass]="{ 'is-invalid': loginFormSubmitted && loginf.email.errors }"
                                                    required>
                                                <div *ngIf="loginFormSubmitted && loginf.email.errors"
                                                    class="invalid-feedback">
                                                    <div *ngIf="loginf.email.errors.required">Email is required</div>
                                                    <div *ngIf="loginf.email.errors.email">Enter valid email address
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="pwd form-lable">
                                                <label for="password_login">Password: <span
                                                        class="mandatory-fields">*</span></label>
                                                <div class="clear"></div>

                                                <p-password [toggleMask]="true" id="password_login"
                                                    formControlName="password" placeholder="Password"
                                                    class="form-control"
                                                    [ngClass]="{ 'is-invalid': loginFormSubmitted && loginf.password.errors }"
                                                    autocomplete="on" required></p-password>
                                                <div *ngIf="loginFormSubmitted && loginf.password.errors"
                                                    class="invalid-feedback">
                                                    <div *ngIf="loginf.password.errors.required">Password is required
                                                    </div>
                                                    <div *ngIf="loginf.password.errors.minlength">Password must be at
                                                        least 6
                                                        characters
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-md-12 input-form">
                                            </div>
                                            <div class="col-md-12 input-form mobile-p-none">
                                                <div *ngIf="isLoginFailed" class="alert alert-danger" role="alert">
                                                    {{errorMessage}}
                                                </div>
                                            </div>
                                            <div class="forgot-p">
                                                <label for="rememberMe">
                                                    <div class="forms">
                                                        <!-- <input class="form-check-input" type="checkbox" value=""
                                                            id="flexCheckDefault"> -->
                                                        <p-checkbox formControlName="rememberMe" binary="true"
                                                            inputId="rememberMe"></p-checkbox>
                                                        <span>Remember me</span>
                                                    </div>
                                                </label>
                                                <label for="forgot-password_login"> <a
                                                        (click)="onClickForgotPassword()">
                                                        Forgot
                                                        Password</a></label>
                                            </div>
                                            <div id="login-submit" class="otp-submit">
                                                <input type="submit" value="Login">
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </p-tabPanel>
                    <p-tabPanel header="Login With OTP" [disabled]="false">
                        <div class="container">
                            <div class="row">
                                <div class="col-md-12 ">
                                    <div *ngIf="!showMobileLoginOtpForm" class="col-md-12 login-page OTP">
                                        <form class="login-form" [formGroup]="mobileLoginForm"
                                            *ngIf="this.mobileLoginForm" (ngSubmit)="onMobilePhoneSubmit()">
                                            <div class="Phone form-lable">
                                                <label for="name_login">Phone Number: <span
                                                        class="mandatory-fields">*</span></label>
                                                <div class="clear"></div>
                                                <p-inputNumber mode="decimal" [useGrouping]="false"
                                                    formControlName="mobileNumber" [maxlength]="10"
                                                    [ngClass]="{ 'is-invalid': submitted && mobNumberFormValidation.mobileNumber.errors }"
                                                    required placeholder="Enter your mobile number">
                                                </p-inputNumber>
                                                <div *ngIf="submitted && mobNumberFormValidation.mobileNumber.errors"
                                                    class="invalid-feedback">
                                                    <div *ngIf="mobNumberFormValidation.mobileNumber.errors.required">
                                                        Mobile number is required.
                                                    </div>
                                                    <div
                                                        *ngIf="!mobNumberFormValidation.mobileNumber.errors.required && mobNumberFormValidation.mobileNumber.errors">
                                                        Please enter a valid 10 digit mobile number.
                                                    </div>
                                                </div>
                                                <div class="invalidmobile" *ngIf="showMobileFormErrors">
                                                    {{mobileFormsErrors}}
                                                </div>
                                            </div>

                                            <div id="login-submit">
                                                <input type="submit" value="Submit">
                                            </div>
                                        </form>
                                    </div>
                                    <div *ngIf="showMobileLoginOtpForm"
                                        class="col-md-12 Otp login-page main-otp-screen">
                                        <div
                                            class="container height-100 d-flex justify-content-center align-items-center">
                                            <div class="position-relative">
                                                <div class="card p-2 text-center">
                                                    <div class="col-md-12 otp-header">
                                                        <div class="row">
                                                            <div class="col-2">
                                                                <div class="back-btn" (click)="onClickOtpback()">
                                                                    <i class="bi bi-chevron-left"></i>
                                                                </div>
                                                            </div>
                                                            <div class="col-10">
                                                                <h2>Login With OTP</h2>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <h6>Please enter the one time password <br> to login your account
                                                    </h6>
                                                    <div> <span>A code has been sent to </span>
                                                        <small>{{mobileNumber}}</small>
                                                    </div>
                                                    <div id="otp"
                                                        class="inputs d-flex flex-row justify-content-center mt-2 mb-2">
                                                        <ng-otp-input #ngOtpInput (onInputChange)="onOtpChange($event)"
                                                            [config]="config">
                                                        </ng-otp-input>
                                                        <div style="display: block;">
                                                            <div *ngIf="showOtpErrors">
                                                                <span style="color: red;">Please enter valid OTP.</span>
                                                            </div>
                                                            <div *ngIf="showOtpLoginErrors">
                                                                <span style="color: red;">{{otpLoginErrors}}</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div>
                                                        <span *ngIf="!showResendButton">{{displayTime}}
                                                            {{transform(counter)}}</span>
                                                        <span *ngIf="showResendButton">
                                                            <div id="">
                                                                <a (click)="resendOtp()"
                                                                    style="text-decoration: underline;cursor: pointer;">Resend</a>
                                                            </div>
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div id="login-submit">
                                            <input type="submit" (click)="onClickOtpLoginSubmit()" value="Submit">
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </p-tabPanel>
                </p-tabView>
            </p-tabPanel>
            <p-tabPanel header=" REGISTER" class="registration-forms" tooltip="Login With OTP Coming Soon!"
                [disabled]="false">
                <div class="container">
                    <div class="row">

                        <div class="col-md-12">
                            <div *ngIf="!showOtpForm" class="col-md-12 login-page ragister-page-div">
                                <form class="login-form" [formGroup]="signUpForm" *ngIf="this.signUpForm"
                                    (ngSubmit)="onSignupSubmit()">
                                    <div class="row">
                                        <div class="Firstname col-6">
                                            <label for="name_login">First Name: <span
                                                    class="mandatory-fields">*</span></label>
                                            <div class="clear"></div>
                                            <input type="text" formControlName="firstName"
                                                class="form-control textCapital " placeholder="First name*" value=""
                                                required
                                                [ngClass]="{ 'is-invalid': submitted && (f.firstName.errors && (f.firstName.dirty || f.firstName.touched))}">
                                            <div *ngIf="((submitted && f.firstName.errors) || (f.firstName.errors && (f.firstName.dirty || f.firstName.touched)))"
                                                class="invalid-feedback">
                                                <div *ngIf="f.firstName.errors.required">First Name is required</div>
                                                <div *ngIf="!f.firstName.errors.required && f.firstName.errors">Only
                                                    Alphabets allowed.</div>
                                            </div>
                                        </div>
                                        <div class="Lastname col-6">
                                            <label for="name_login">Last Name: <span
                                                    class="mandatory-fields">*</span></label>
                                            <div class="clear"></div>
                                            <input type="text" formControlName="lastName"
                                                class="form-control textCapital" placeholder="Last name*" value=""
                                                required
                                                [ngClass]="{ 'is-invalid': submitted && (f.lastName.errors && (f.lastName.dirty || f.lastName.touched))}">
                                            <div *ngIf="((submitted && f.lastName.errors) || (f.lastName.errors && (f.lastName.dirty || f.lastName.touched)))"
                                                class="invalid-feedback">
                                                <div *ngIf="f.lastName.errors.required">Last Name is required</div>
                                                <div *ngIf="!f.lastName.errors.required && f.lastName.errors">Only
                                                    Alphabets allowed.</div>
                                            </div>
                                        </div>
                                        <div class="Email col-6">
                                            <label for="name_login">Email: <span
                                                    class="mandatory-fields">*</span></label>
                                            <div class="clear"></div>
                                            <input type="email" formControlName="email" placeholder="Email Address*"
                                                class="form-control mb-3"
                                                [ngClass]="{ 'is-invalid': submitted && (f.email.errors && (f.email.dirty || f.email.touched)) }">
                                            <div *ngIf="((submitted && f.email.errors) || (f.email.errors && (f.email.dirty || f.email.touched)))"
                                                class="invalid-feedback">
                                                <div *ngIf="f.email.errors.required">Email is required</div>
                                                <div *ngIf="!f.email.errors.required && f.email.errors.email">Enter
                                                    valid email address</div>
                                            </div>
                                        </div>
                                        <div class="Phone col-6">
                                            <label for="name_login">Phone Number: <span
                                                    class="mandatory-fields">*</span></label>
                                            <div class="clear"></div>
                                            <p-inputNumber mode="decimal" [useGrouping]="false"
                                                formControlName="mobileNumber" [maxlength]="10"
                                                [ngClass]="{ 'is-invalid': submitted && (f.mobileNumber.invalid && (f.mobileNumber.dirty || f.mobileNumber.touched))}"
                                                required placeholder="Enter Mobile Number">
                                            </p-inputNumber>
                                            <div *ngIf="((submitted && f.mobileNumber.errors) || (f.mobileNumber.errors && (f.mobileNumber.dirty || f.mobileNumber.touched)))"
                                                class="invalid-feedback">
                                                <div *ngIf="f.mobileNumber.errors.required">Mobile number is
                                                    required.</div>
                                                <div *ngIf="!f.mobileNumber.errors.required && f.mobileNumber.invalid">
                                                    Please enter a valid 10 digit mobile number.</div>
                                            </div>
                                        </div>
                                        <div class="p-field col-6">
                                            <label for="country">Country <span class="mandatory-fields">*</span></label>
                                            <!-- <p-dropdown inputId="country" [options]="countrylist"
                                                formControlName="country" [filter]="true" (onChange)="getStates($event)"
                                                placeholder="Select Country" optionLabel="name"
                                                [ngClass]="{ 'is-invalid': submitted && f.country.errors }"></p-dropdown>
                                            <div *ngIf="submitted && f.country.errors" class="invalid-feedback">
                                                <div *ngIf="f.country.errors.required">Please select country</div>
                                            </div> -->
                                            <p-dropdown inputId="country" [options]="countrylist"
                                                formControlName="country" [filter]="true"
                                                (onChange)="getStates(true,$event)" placeholder="Select Country"
                                                optionLabel="name"
                                                [ngClass]="{ 'is-invalid': submitted && (f.country.invalid && (f.country.dirty || f.country.touched))}"></p-dropdown>
                                            <div *ngIf="((submitted && f.country.errors) || (f.country.errors && (f.country.dirty || f.country.touched)))"
                                                class="invalid-feedback">
                                                <div *ngIf="f.country.errors.required">Please Select Country.
                                                </div>
                                            </div>
                                        </div>
                                        <div class="p-field col-6">
                                            <label for="state">State: <span class="mandatory-fields">*</span></label>
                                            <!-- <p-dropdown inputId="state" [options]="stateList" formControlName="state"
                                                [filter]="true" (onChange)="setState($event)" placeholder="Select State"
                                                optionLabel="name"
                                                [ngClass]="{ 'is-invalid': submitted && f.state.errors }"></p-dropdown>
                                            <div *ngIf="submitted && f.state.errors" class="invalid-feedback">
                                                <div *ngIf="f.state.errors.required">Please select state</div>
                                            </div> -->
                                            <p-dropdown inputId="state" [options]="stateList" formControlName="state"
                                                [filter]="true" (onChange)="setState($event)" placeholder="Select State"
                                                optionLabel="name"
                                                [ngClass]="{ 'is-invalid': submitted && (f.state.invalid && (f.state.dirty || f.state.touched))}"></p-dropdown>
                                            <div *ngIf="((submitted && f.state.errors) || (f.state.errors && (f.state.dirty || f.state.touched)))"
                                                class="invalid-feedback">
                                                <div *ngIf="f.state.errors.required">Please Select State.
                                                </div>
                                            </div>
                                        </div>
                                        <div class="city col-6 mb-3">
                                            <label for="name_login">City: <span
                                                    class="mandatory-fields">*</span></label>
                                            <div class="clear"></div>
                                            <!-- <p-dropdown inputId="city" [filter]="true" [options]="cityList"
                                                formControlName="city" (onChange)="onCitySelect($event)"
                                                placeholder="Select City" optionLabel="name"></p-dropdown> -->
                                            <p-dropdown inputId="city" [options]="cityList" formControlName="city"
                                                [filter]="true" placeholder="Select City" optionLabel="name"
                                                (onChange)="onCitySelect($event)"
                                                [ngClass]="{ 'is-invalid': submitted && (f.city.invalid && (f.city.dirty || f.city.touched))}"></p-dropdown>
                                            <div *ngIf="((submitted && f.city.errors) || (f.city.errors && (f.city.dirty || f.city.touched)))"
                                                class="invalid-feedback">
                                                <div *ngIf="f.city.errors.required">Please Select City.
                                                </div>
                                            </div>
                                        </div>
                                        <div class="Gender  col-6 mb-3">
                                            <label for="name_login">Gender:</label>
                                            <div class="clear"></div>
                                            <!-- <select class="form-select" aria-label=".form-select-sm example">
                                                <option selected>Select Gender</option>
                                                <option value="1">Male</option>
                                                <option value="2">Female</option>
                                                <option value="3">Other</option>
                                            </select> -->
                                            <p-dropdown inputId="gender" [filter]="true" [options]="genders"
                                                formControlName="gender" (onChange)="onGenderSelect($event)"
                                                placeholder="Select Gender" optionLabel="name"></p-dropdown>
                                        </div>
                                        <div class="pwd col-6">
                                            <label for="password_login">Password: <span
                                                    class="mandatory-fields">*</span></label>
                                            <div class="clear"></div>
                                            <p-password [toggleMask]="true" id="password_login" type="password"
                                                formControlName="password" placeholder="********" class="form-control"
                                                value="" autocomplete="on" required
                                                [ngClass]="{ 'is-invalid': submitted && (f.password.invalid && (f.password.dirty || f.password.touched))}"></p-password>
                                            <div *ngIf="((submitted && f.password.errors) || (f.password.errors && (f.password.dirty || f.password.touched)))"
                                                class="invalid-feedback">
                                                <div *ngIf="f.password.errors.required">Password is required</div>
                                                <div *ngIf="!f.password.errors.required && f.password.errors">Password
                                                    should contains at least 1
                                                    digit, 1 lowercase, 1 uppercase, 1 symbol. Length between 6 to 20.
                                                </div>
                                            </div>
                                        </div>
                                        <div class="pwd col-6">
                                            <label for="password_login">Confirm Password: <span
                                                    class="mandatory-fields">*</span></label>
                                            <div class="clear"></div>
                                            <p-password [toggleMask]="true" type="password"
                                                formControlName="confirmPassword" placeholder="Confirm Password*"
                                                class="form-control" autocomplete="on" required
                                                [ngClass]="{ 'is-invalid': submitted && (f.confirmPassword.invalid && (f.confirmPassword.dirty || f.confirmPassword.touched))}"></p-password>
                                            <!-- <div *ngIf="submitted && f.confirmPassword.errors" class="invalid-feedback"> -->
                                            <div *ngIf="((submitted && f.confirmPassword.errors) || (f.confirmPassword.errors && (f.confirmPassword.dirty || f.confirmPassword.touched)))"
                                                class="invalid-feedback">
                                                <div *ngIf="f.confirmPassword.errors.required">Confirm Password is
                                                    required</div>
                                                <div
                                                    *ngIf="!f.confirmPassword.errors.required && f.confirmPassword.errors.mustMatch">
                                                    Passwords must match</div>
                                            </div>
                                        </div>
                                        <!-- <div class="col-md-6 input-form dates">
                                            <span class="outline-element-container">
                                                <label for="referral"> Date Of Birth:<span
                                                        class="mandatory-fields">*</span></label>
                                                <p-calendar formControlName="dob" [showIcon]="true" inputId="icon"
                                                    placeholder="Birth Date" monthNavigator="true" yearNavigator="true"
                                                    yearRange="{{yearRange}}" class="p-calendar" inputId="calendar"
                                                    [defaultDate]="date" dateFormat="dd/mm/yy" [showIcon]="true"
                                                    [ngClass]="{ 'is-invalid': submitted && (f.dob.errors && (f.dob.dirty || f.dob.touched))}"></p-calendar>

                                                <div *ngIf="submitted && f.dob.errors" class="invalid-feedback">
                                                    
                                                <div *ngIf="((submitted && f.dob.errors) || (f.dob.errors && (f.dob.dirty || f.dob.touched)))"
                                                    class="invalid-feedback">
                                                    <div *ngIf="f.dob.errors.required">Date Of Birth is
                                                        required
                                                    </div>
                                                </div>
                                            </span>
                                        </div> -->


                                        <!-- DOB Validattion Issue Fixed Updated Code -->

                                        <div class="col-md-6 input-form dates">
                                            <span class="outline-element-container">
                                                <label for="referral"> Date Of Birth:<span
                                                        class="mandatory-fields">*</span></label>
                                                <p-calendar formControlName="dob" [readonlyInput]="true"
                                                    placeholder="Birth Date" monthNavigator="true" yearNavigator="true"
                                                    yearRange="{{yearRange}}" class="p-calendar" inputId="calendar"
                                                    [defaultDate]="date" dateFormat="dd/mm/yy" [showIcon]="true"
                                                    [ngClass]="{ 'is-invalid': submitted && f.dob.invalid && (f.dob.dirty || f.dob.touched) }">
                                                </p-calendar>
                                                <div *ngIf="submitted && f.dob.invalid && (f.dob.dirty || f.dob.touched)"
                                                    class="invalid-feedback">
                                                    <div *ngIf="f.dob.errors.required">Date Of Birth is required</div>
                                                </div>
                                            </span>
                                        </div>

                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </p-tabPanel>
        </p-tabView>
    </div>
</section>
<section *ngIf="showForgotPasswordForm" class="login-page-section forgot-password">
    <div class="section-title text-center">
        <p> Forgot Password
        </p>
    </div>
    <div class="container">
        <div class="row">
            <div class="col-md-12 ">
                <div class="col-md-12 login-page">
                    <form [formGroup]="forgotPassForm">
                        <div class="row">
                            <div class="col-lg-12">
                                <div class="style-form-group forgot-password-div form-lable">
                                    <label _ngcontent-jec-c294="" for="name_login">Email:<span _ngcontent-jec-c294=""
                                            class="mandatory-fields">*</span></label>
                                    <input type="email" formControlName="email" class="form-control form-input"
                                        placeholder="Enter Your Email "
                                        [ngClass]="{ 'is-invalid': submitted && forgotPassValidation.email.errors }">
                                    <div *ngIf="submitted && forgotPassValidation.email.errors"
                                        class="invalid-feedback">
                                        <div *ngIf="forgotPassValidation.email.errors.required">Email is
                                            required.</div>
                                        <div *ngIf="forgotPassValidation.email.errors.pattern">Please enter a
                                            valid
                                            email id.</div>
                                    </div>
                                    <div *ngIf="successMessage" style="color:green;">{{successMessage.message}}
                                    </div>
                                    <div *ngIf="errorMessage" style="color:red;">{{errorMessage}}</div>
                                </div>
                            </div>
                        </div>
                        <div class="button pt-2 pt-lg-3">
                            <button class="forgot-pass-back" (click)="onForgotPassBack()">Back</button> &nbsp;&nbsp;

                            <button class="forgot-pass-submit" (click)="onForgotPassSubmit()">Submit</button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</section>